module.exports = __webpack_public_path__ + "img/6_145.89465905.png";